import React from 'react'
import { Grid } from 'semantic-ui-react'

// @ts-ignore
import { GridContainer } from 'shared/StyledComponents'

import AddressInformation from './AddressInformation'
import ContactInformation from './ContactInformation'

const SecondPage = ({ fields, selects, cityList, dynamicOptions, onTranslateAltRequest, onCountryChange }) => (
  <GridContainer smallPadding>
    <Grid>
      <AddressInformation
        dynamicOptions={dynamicOptions}
        fields={fields}
        selects={selects}
        cityList={cityList}
        onTranslateAltRequest={onTranslateAltRequest}
        onCountryChange={onCountryChange}
      />

      <ContactInformation fields={fields} selects={selects} />
    </Grid>
  </GridContainer>
)

export default SecondPage
